import RichTextOpenTemplateDrawer from './RichTextOpenTemplateDrawer';

export default RichTextOpenTemplateDrawer;
